module.exports = __webpack_public_path__ + "img/cross.35bf465e.svg";